/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DashboardExerciseProgress } from '../entities';
// @ts-ignore
import type { DashboardExerciseProgressRequest } from '../entities';
// @ts-ignore
import type { DashboardExerciseResponse } from '../entities';
// @ts-ignore
import type { DashboardExerciseSummary } from '../entities';
// @ts-ignore
import type { DashboardHomeResponse } from '../entities';
// @ts-ignore
import type { DashboardMostTrainedGroup } from '../entities';
// @ts-ignore
import type { DashboardSessionExerciseSummaryRequest } from '../entities';
// @ts-ignore
import type { DashboardSessionSummary } from '../entities';
// @ts-ignore
import type { DashboardTimeframedRequest } from '../entities';
// @ts-ignore
import type { DashboardWorkoutExerciseSummaryRequest } from '../entities';
// @ts-ignore
import type { HomeMuscleGroupRanking } from '../entities';
// @ts-ignore
import type { MostTrainedExercise } from '../entities';
// @ts-ignore
import type { Workout } from '../entities';
// @ts-ignore
import type { WorkoutFrequency } from '../entities';
// @ts-ignore
import type { WorkoutRequest } from '../entities';
/**
 * DashboardControllerApi - axios parameter creator
 * @export
 */
export const DashboardControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTrainedExercise: async (dashboardTimeframedRequest: DashboardTimeframedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardTimeframedRequest' is not null or undefined
            assertParamExists('getAllTrainedExercise', 'dashboardTimeframedRequest', dashboardTimeframedRequest)
            const localVarPath = `/dashboard/home/trainedExercises`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardTimeframedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTrainedGroups: async (dashboardTimeframedRequest: DashboardTimeframedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardTimeframedRequest' is not null or undefined
            assertParamExists('getAllTrainedGroups', 'dashboardTimeframedRequest', dashboardTimeframedRequest)
            const localVarPath = `/dashboard/home/trainedGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardTimeframedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardExerciseProgressRequest} dashboardExerciseProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardExercise: async (dashboardExerciseProgressRequest: DashboardExerciseProgressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardExerciseProgressRequest' is not null or undefined
            assertParamExists('getDashboardExercise', 'dashboardExerciseProgressRequest', dashboardExerciseProgressRequest)
            const localVarPath = `/dashboard/exercise`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardExerciseProgressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardExerciseProgressRequest} dashboardExerciseProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardExerciseProgress: async (dashboardExerciseProgressRequest: DashboardExerciseProgressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardExerciseProgressRequest' is not null or undefined
            assertParamExists('getDashboardExerciseProgress', 'dashboardExerciseProgressRequest', dashboardExerciseProgressRequest)
            const localVarPath = `/dashboard/exercise/progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardExerciseProgressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardExerciseProgressRequest} dashboardExerciseProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardExerciseSummary: async (dashboardExerciseProgressRequest: DashboardExerciseProgressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardExerciseProgressRequest' is not null or undefined
            assertParamExists('getDashboardExerciseSummary', 'dashboardExerciseProgressRequest', dashboardExerciseProgressRequest)
            const localVarPath = `/dashboard/exercise/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardExerciseProgressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardHome: async (dashboardTimeframedRequest: DashboardTimeframedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardTimeframedRequest' is not null or undefined
            assertParamExists('getDashboardHome', 'dashboardTimeframedRequest', dashboardTimeframedRequest)
            const localVarPath = `/dashboard/home`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardTimeframedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardSessionExerciseSummaryRequest} dashboardSessionExerciseSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardSessionExerciseSummary: async (dashboardSessionExerciseSummaryRequest: DashboardSessionExerciseSummaryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardSessionExerciseSummaryRequest' is not null or undefined
            assertParamExists('getDashboardSessionExerciseSummary', 'dashboardSessionExerciseSummaryRequest', dashboardSessionExerciseSummaryRequest)
            const localVarPath = `/dashboard/session/summary/exercise`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardSessionExerciseSummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardWorkoutExerciseSummaryRequest} dashboardWorkoutExerciseSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardWorkoutExerciseSummary: async (dashboardWorkoutExerciseSummaryRequest: DashboardWorkoutExerciseSummaryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardWorkoutExerciseSummaryRequest' is not null or undefined
            assertParamExists('getDashboardWorkoutExerciseSummary', 'dashboardWorkoutExerciseSummaryRequest', dashboardWorkoutExerciseSummaryRequest)
            const localVarPath = `/dashboard/workout/summary/exercise`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardWorkoutExerciseSummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMostTrainedExercise: async (dashboardTimeframedRequest: DashboardTimeframedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardTimeframedRequest' is not null or undefined
            assertParamExists('getMostTrainedExercise', 'dashboardTimeframedRequest', dashboardTimeframedRequest)
            const localVarPath = `/dashboard/home/exercise`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardTimeframedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMuscleGroupRanking: async (dashboardTimeframedRequest: DashboardTimeframedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardTimeframedRequest' is not null or undefined
            assertParamExists('getMuscleGroupRanking', 'dashboardTimeframedRequest', dashboardTimeframedRequest)
            const localVarPath = `/dashboard/home/muscles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardTimeframedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionSummary: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSessionSummary', 'id', id)
            const localVarPath = `/dashboard/session/summary/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkoutFrequency: async (dashboardTimeframedRequest: DashboardTimeframedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardTimeframedRequest' is not null or undefined
            assertParamExists('getWorkoutFrequency', 'dashboardTimeframedRequest', dashboardTimeframedRequest)
            const localVarPath = `/dashboard/home/frequency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardTimeframedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WorkoutRequest} workoutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkoutHeadStatus: async (workoutRequest: WorkoutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workoutRequest' is not null or undefined
            assertParamExists('getWorkoutHeadStatus', 'workoutRequest', workoutRequest)
            const localVarPath = `/dashboard/workouts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workoutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkoutSummary: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWorkoutSummary', 'id', id)
            const localVarPath = `/dashboard/workout/summary/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardControllerApi - functional programming interface
 * @export
 */
export const DashboardControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTrainedExercise(dashboardTimeframedRequest: DashboardTimeframedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MostTrainedExercise>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTrainedExercise(dashboardTimeframedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.getAllTrainedExercise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTrainedGroups(dashboardTimeframedRequest: DashboardTimeframedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DashboardMostTrainedGroup>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTrainedGroups(dashboardTimeframedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.getAllTrainedGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DashboardExerciseProgressRequest} dashboardExerciseProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardExercise(dashboardExerciseProgressRequest: DashboardExerciseProgressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardExerciseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardExercise(dashboardExerciseProgressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.getDashboardExercise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DashboardExerciseProgressRequest} dashboardExerciseProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardExerciseProgress(dashboardExerciseProgressRequest: DashboardExerciseProgressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DashboardExerciseProgress>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardExerciseProgress(dashboardExerciseProgressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.getDashboardExerciseProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DashboardExerciseProgressRequest} dashboardExerciseProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardExerciseSummary(dashboardExerciseProgressRequest: DashboardExerciseProgressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardExerciseSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardExerciseSummary(dashboardExerciseProgressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.getDashboardExerciseSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardHome(dashboardTimeframedRequest: DashboardTimeframedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardHomeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardHome(dashboardTimeframedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.getDashboardHome']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DashboardSessionExerciseSummaryRequest} dashboardSessionExerciseSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardSessionExerciseSummary(dashboardSessionExerciseSummaryRequest: DashboardSessionExerciseSummaryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DashboardExerciseSummary>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardSessionExerciseSummary(dashboardSessionExerciseSummaryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.getDashboardSessionExerciseSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DashboardWorkoutExerciseSummaryRequest} dashboardWorkoutExerciseSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardWorkoutExerciseSummary(dashboardWorkoutExerciseSummaryRequest: DashboardWorkoutExerciseSummaryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DashboardExerciseSummary>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardWorkoutExerciseSummary(dashboardWorkoutExerciseSummaryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.getDashboardWorkoutExerciseSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMostTrainedExercise(dashboardTimeframedRequest: DashboardTimeframedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MostTrainedExercise>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMostTrainedExercise(dashboardTimeframedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.getMostTrainedExercise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMuscleGroupRanking(dashboardTimeframedRequest: DashboardTimeframedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HomeMuscleGroupRanking>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMuscleGroupRanking(dashboardTimeframedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.getMuscleGroupRanking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionSummary(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardSessionSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionSummary(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.getSessionSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkoutFrequency(dashboardTimeframedRequest: DashboardTimeframedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkoutFrequency>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkoutFrequency(dashboardTimeframedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.getWorkoutFrequency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WorkoutRequest} workoutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkoutHeadStatus(workoutRequest: WorkoutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Workout>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkoutHeadStatus(workoutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.getWorkoutHeadStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkoutSummary(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardSessionSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkoutSummary(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.getWorkoutSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DashboardControllerApi - factory interface
 * @export
 */
export const DashboardControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTrainedExercise(dashboardTimeframedRequest: DashboardTimeframedRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<MostTrainedExercise>> {
            return localVarFp.getAllTrainedExercise(dashboardTimeframedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTrainedGroups(dashboardTimeframedRequest: DashboardTimeframedRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<DashboardMostTrainedGroup>> {
            return localVarFp.getAllTrainedGroups(dashboardTimeframedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardExerciseProgressRequest} dashboardExerciseProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardExercise(dashboardExerciseProgressRequest: DashboardExerciseProgressRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardExerciseResponse> {
            return localVarFp.getDashboardExercise(dashboardExerciseProgressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardExerciseProgressRequest} dashboardExerciseProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardExerciseProgress(dashboardExerciseProgressRequest: DashboardExerciseProgressRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<DashboardExerciseProgress>> {
            return localVarFp.getDashboardExerciseProgress(dashboardExerciseProgressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardExerciseProgressRequest} dashboardExerciseProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardExerciseSummary(dashboardExerciseProgressRequest: DashboardExerciseProgressRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardExerciseSummary> {
            return localVarFp.getDashboardExerciseSummary(dashboardExerciseProgressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardHome(dashboardTimeframedRequest: DashboardTimeframedRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardHomeResponse> {
            return localVarFp.getDashboardHome(dashboardTimeframedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardSessionExerciseSummaryRequest} dashboardSessionExerciseSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardSessionExerciseSummary(dashboardSessionExerciseSummaryRequest: DashboardSessionExerciseSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<DashboardExerciseSummary>> {
            return localVarFp.getDashboardSessionExerciseSummary(dashboardSessionExerciseSummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardWorkoutExerciseSummaryRequest} dashboardWorkoutExerciseSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardWorkoutExerciseSummary(dashboardWorkoutExerciseSummaryRequest: DashboardWorkoutExerciseSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<DashboardExerciseSummary>> {
            return localVarFp.getDashboardWorkoutExerciseSummary(dashboardWorkoutExerciseSummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMostTrainedExercise(dashboardTimeframedRequest: DashboardTimeframedRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<MostTrainedExercise>> {
            return localVarFp.getMostTrainedExercise(dashboardTimeframedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMuscleGroupRanking(dashboardTimeframedRequest: DashboardTimeframedRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<HomeMuscleGroupRanking>> {
            return localVarFp.getMuscleGroupRanking(dashboardTimeframedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionSummary(id: number, options?: RawAxiosRequestConfig): AxiosPromise<DashboardSessionSummary> {
            return localVarFp.getSessionSummary(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkoutFrequency(dashboardTimeframedRequest: DashboardTimeframedRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkoutFrequency> {
            return localVarFp.getWorkoutFrequency(dashboardTimeframedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkoutRequest} workoutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkoutHeadStatus(workoutRequest: WorkoutRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Workout>> {
            return localVarFp.getWorkoutHeadStatus(workoutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkoutSummary(id: number, options?: RawAxiosRequestConfig): AxiosPromise<DashboardSessionSummary> {
            return localVarFp.getWorkoutSummary(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardControllerApi - object-oriented interface
 * @export
 * @class DashboardControllerApi
 * @extends {BaseAPI}
 */
export class DashboardControllerApi extends BaseAPI {
    /**
     * 
     * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardControllerApi
     */
    public getAllTrainedExercise(dashboardTimeframedRequest: DashboardTimeframedRequest, options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).getAllTrainedExercise(dashboardTimeframedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardControllerApi
     */
    public getAllTrainedGroups(dashboardTimeframedRequest: DashboardTimeframedRequest, options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).getAllTrainedGroups(dashboardTimeframedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardExerciseProgressRequest} dashboardExerciseProgressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardControllerApi
     */
    public getDashboardExercise(dashboardExerciseProgressRequest: DashboardExerciseProgressRequest, options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).getDashboardExercise(dashboardExerciseProgressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardExerciseProgressRequest} dashboardExerciseProgressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardControllerApi
     */
    public getDashboardExerciseProgress(dashboardExerciseProgressRequest: DashboardExerciseProgressRequest, options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).getDashboardExerciseProgress(dashboardExerciseProgressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardExerciseProgressRequest} dashboardExerciseProgressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardControllerApi
     */
    public getDashboardExerciseSummary(dashboardExerciseProgressRequest: DashboardExerciseProgressRequest, options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).getDashboardExerciseSummary(dashboardExerciseProgressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardControllerApi
     */
    public getDashboardHome(dashboardTimeframedRequest: DashboardTimeframedRequest, options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).getDashboardHome(dashboardTimeframedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardSessionExerciseSummaryRequest} dashboardSessionExerciseSummaryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardControllerApi
     */
    public getDashboardSessionExerciseSummary(dashboardSessionExerciseSummaryRequest: DashboardSessionExerciseSummaryRequest, options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).getDashboardSessionExerciseSummary(dashboardSessionExerciseSummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardWorkoutExerciseSummaryRequest} dashboardWorkoutExerciseSummaryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardControllerApi
     */
    public getDashboardWorkoutExerciseSummary(dashboardWorkoutExerciseSummaryRequest: DashboardWorkoutExerciseSummaryRequest, options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).getDashboardWorkoutExerciseSummary(dashboardWorkoutExerciseSummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardControllerApi
     */
    public getMostTrainedExercise(dashboardTimeframedRequest: DashboardTimeframedRequest, options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).getMostTrainedExercise(dashboardTimeframedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardControllerApi
     */
    public getMuscleGroupRanking(dashboardTimeframedRequest: DashboardTimeframedRequest, options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).getMuscleGroupRanking(dashboardTimeframedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardControllerApi
     */
    public getSessionSummary(id: number, options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).getSessionSummary(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardTimeframedRequest} dashboardTimeframedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardControllerApi
     */
    public getWorkoutFrequency(dashboardTimeframedRequest: DashboardTimeframedRequest, options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).getWorkoutFrequency(dashboardTimeframedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkoutRequest} workoutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardControllerApi
     */
    public getWorkoutHeadStatus(workoutRequest: WorkoutRequest, options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).getWorkoutHeadStatus(workoutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardControllerApi
     */
    public getWorkoutSummary(id: number, options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).getWorkoutSummary(id, options).then((request) => request(this.axios, this.basePath));
    }
}

